// extracted by mini-css-extract-plugin
module.exports = {"copyInputIconWrap":"CopyType_copyInputIconWrap__4qKhN","copyTypeIcon":"CopyType_copyTypeIcon__cIAJO","formControlIconWrap":"CopyType_formControlIconWrap__0Vv6_"};